import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from './components/headers/Header';
import RequireAuth from './components/shared/RequireAuth';
import ReloadButton from './components/shared/ReloadButton';

import Dashboard from './pages/Dashboard';
import Tickets from './pages/Tickets';
import Events from './pages/Events';
import Event from './pages/Event';
import Users from './pages/Users';
import Cache from './pages/cache';
import Inbox from './pages/Inbox';
import MessagesPage from './pages/MessagesPage';
import Transactions from './pages/Transactions';
import NotFound from './pages/NotFound';

function App() {
    return (
        <BrowserRouter>
            <Header />
            <ReloadButton />
            <Routes>
                <Route path='/' element={<RequireAuth><Events /></RequireAuth>} />
                <Route path='/dashboard' element={<RequireAuth><Dashboard /></RequireAuth>} />
                <Route path='/events' element={<RequireAuth><Events /></RequireAuth>} />
                <Route path='/tickets' element={<RequireAuth><Tickets /></RequireAuth>} />
                <Route path='/users' element={<RequireAuth><Users /></RequireAuth>} />
                <Route path='/transactions' element={<RequireAuth><Transactions /></RequireAuth>} />
                <Route path='/cache' element={<RequireAuth><Cache /></RequireAuth>} />
                <Route path='/inbox' element={<RequireAuth><Inbox type='support' /></RequireAuth>} />
                <Route path='/event' element={<RequireAuth><Event /></RequireAuth>} />
                <Route path='/messages' element={<RequireAuth><MessagesPage /></RequireAuth>} />
                <Route path='*' element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
